import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { CaisReportCreateDrawer } from '../../../../../../../../../../features/trade-reporting/cais/cais-report-create-drawer';
import { TradeReportingCaisReportsTable } from '../../../../../../../../../../features/trade-reporting/cais/cais-reports-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingComplianceReporting,
      label: 'CAIS',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingComplianceReporting>,
  head: () => getPageHead('CAIS Reports'),
  component: CaisReportList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <CaisReportCreateDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New CAIS Report" size="small" />} />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingComplianceReporting}
    />
  );
}

function CaisReportList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <TradeReportingCaisReportsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
